import httpClient, { IRequest, IResponse } from '../../../apiService/httpClient';
import { IUser } from '../../shared/iUser';
import { ILogoutResponse } from './iApiResponse';

const BeMaccaferriIdentityProvider = () => {
    let _baseURL = process.env.REACT_APP_IDENTITY_BASE_URL as string;

    const _createRequest = <D>(_pathname: string, _queryString?: string, _data?: D): IRequest => {
        return {
            url: _queryString ? _pathname + '?' + _queryString : _pathname,
            baseURL: _baseURL,
            data: _data,
        };
    };

    const getUserAsync = async (): Promise<IResponse<IUser>> => httpClient.getAsync(_createRequest('/IdentityV2/GetUser'));

    const logoutAsync = async (): Promise<IResponse<ILogoutResponse>> => httpClient.getAsync(_createRequest('/Identity/Logout'));

    return {
        getUserAsync,
        logoutAsync,
    };
};
export default BeMaccaferriIdentityProvider();
